type Status = 'pending' | 'success' | 'error';

type Resource<T> = {
  read: () => T;
};

const cache = new Map<string, Resource<any>>();

export const createResource = <T>(key: string, promiseFn: () => Promise<T>): Resource<T> => {
  if (cache.has(key)) {
    return cache.get(key)!;
  }

  let status: Status = 'pending';
  let result: T;
  let error: any;

  const suspender = promiseFn()
    .then(res => {
      status = 'success';
      result = res;
    })
    .catch(err => {
      status = 'error';
      error = err;
    });

  const resource: Resource<T> = {
    read() {
      if (status === 'pending') throw suspender;
      if (status === 'error') throw error;
      return result;
    }
  };

  cache.set(key, resource);
  return resource;
};
